import { ItemSelection } from 'src/types';
import { createAction } from 'redux-actions';
import { IRAAutoMaxCartDetailsState } from '.';
import { IRAAutoMaxCartActionTypes as act } from './actionTypes';
import { getEndpoint } from 'src/utils/api';
import { callApi } from 'src/utils/api';

export const defaultState: IRAAutoMaxCartDetailsState = {
  // Month/Day Selections
  monthsForPayments: [],
  daysOfMonthPayments: [],

  // Window API Fetch
  isLoading: false,
  loading: false,
  validationFailed: false,
  isLoaded: false,
  hasFailed: false,
  error: null,
  firstAvailableDate: null,
  lastAvailableDate: null,
  iraAutoMaxWindowOpen: true,
  eligibleAgreementExist: true,
};
export default function iraAutoMaxCartDetails(
  state: IRAAutoMaxCartDetailsState = defaultState,
  { payload, type }
): IRAAutoMaxCartDetailsState {
  switch (type) {
    case act.IRA_AUTO_MAX_WINDOW_PENDING:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case act.IRA_AUTO_MAX_WINDOW_FULFILLED:
      const { body } = payload;
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        // ISO 8601 date -> JS Date object
        firstAvailableDate: new Date(body.firstAvailableDate),
        lastAvailableDate: new Date(body.lastAvailableDate),
        iraAutoMaxWindowOpen: body.iraAutoMaxWindowOpen,
        eligibleAgreementExist: body.eligibleAgreementExist,
      };

    case act.IRA_AUTO_MAX_WINDOW_REJECTED:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload,
      };
    case act.IRA_AUTO_MAX_SELECT_DAY:
      return {
        ...state,
        daysOfMonthPayments: payload,
      };
    case act.IRA_AUTO_MAX_SELECT_MONTH:
      return {
        ...state,
        monthsForPayments: payload,
      };

    default:
      return state;
  }
}

export const setIRAAutoMaxDays = (list: ItemSelection[]) => ({
  type: act.IRA_AUTO_MAX_SELECT_DAY,
  payload: list,
});

export const setIRAAutoMaxMonths = (list: ItemSelection[]) => ({
  type: act.IRA_AUTO_MAX_SELECT_MONTH,
  payload: list,
});

export const getIRAAutoMaxWindow = () => {
  return () => {
    const iraAutoMaxWindowEndpoint = getEndpoint('iraAutoMaxWindow');
    return createAction(act.IRA_AUTO_MAX_WINDOW)(
      callApi(`${iraAutoMaxWindowEndpoint}`)
    );
  };
};
